import styled from "styled-components";

export const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 160px;

    > label {
        font-size: var(--type-paragraph-font-size);
        font-weight: 700;
        line-height: var(--type-paragraph-line-height);
        margin-bottom: 8px;
    }
`;

export const SelectWrapper = styled.div`
    position: relative;

    &::after {
        --size: 10px;

        border-bottom: 4px solid var(--color-black);
        border-radius: 2px;
        border-right: 4px solid var(--color-black);
        content: "";
        height: var(--size);
        position: absolute;
        right: 18px;
        top: 50%;
        transform: translateY(-70%) rotate(45deg);
        width: var(--size);
    }
`;

export const StyledSelect = styled.select`
    appearance: none;
    background-color: var(--color-grey-45);
    border: 1px;
    border-radius: 28px;
    height: 54px;
    padding: 16px 24px 16px 16px;
    width: 100%;

    &:focus {
        background-color: var(--color-white);
        border: var(--color-white);
        box-shadow: 0 0 6px var(--color-primaryLight);
        outline: none;
    }
`;
